export enum userCreateDistrictTypes {
  SET_USERCREATE_DISTRICT = "SET_USERCREATE_DISTRICT",
  SET_USERCREATE_UNIT = "SET_USERCREATE_UNIT",
  GET_USERCREATE_UNIT = "GET_USERCREATE_UNIT",
}
